import React from 'react';

const Loadable = React.lazy(() => import('../../pages/Team/Team'));

export default Loadable;
